export class CustomFilter {
  id: number = 0;
  filterName: string = '';
  // firstName: string = '';
  // lastName: string = '';
  // patientId: number = 0;
  arBucket: number = 0;
  amount: number = 0;
  amountFilter: number = 0;
  paymentStatus: number = 0;
  practiceId: number = 0;
}
